import { Auth } from "./Auth";

export class AuthJWT implements Auth {
  private auth: { [key: string]: string } = { Authorization: "Bearer " };
  private expireIn = -1;

  public setAuth(token: string, expireIn?: number): void {
    this.auth.Authorization = "Bearer " + token;

    if (expireIn) {
      this.expireIn = expireIn;
    }
  }

  public getAuth(): { [key: string]: string } {
    return this.auth;
  }

  public getAuthKey(): string {
    return "Authorization";
  }

  public doesTokenExpire(): boolean {
    const dateTime = Date.now();
    const timestamp = Math.floor(dateTime / 1000);

    return this.expireIn + 10 >= timestamp;
  }
}
